import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import apiService from './api'
import { Vertical } from 'types/vertical'

export const VERTICALS_QUERY_KEY = ['verticals'] as const

export const useVerticalsQuery = () => {
  return useQuery({
    queryKey: VERTICALS_QUERY_KEY,
    queryFn: async () => {
      const result = await apiService.verticals()
      if (result?.verticals) return result.verticals.filter((vertical: Vertical) => vertical.id !== 'nft') as Vertical[]
      return []
    },
    refetchOnWindowFocus: false,
  })
}

export const useEnabledVerticalIds = () => {
  const { data: verticals, isLoading } = useVerticalsQuery()
  const enabledIds = verticals?.filter(v => v.isEnabled).map(v => v.id) ?? []
  return { enabledVerticalIds: enabledIds, isLoading }
}

export const useUpdateVerticalEnabled = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: ({ id, isEnabled }: { id: string; isEnabled: boolean }) => apiService.updateVertical(id, isEnabled),
  })

  const updateVertical = async (id: string, isEnabled: boolean) => {
    await mutation.mutateAsync({ id, isEnabled })
    queryClient.invalidateQueries({ queryKey: VERTICALS_QUERY_KEY })
  }

  return { updateVertical, isPending: mutation.isPending }
}
